'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _retry = require('../utilities/retry');

var _retry2 = _interopRequireDefault(_retry);

var _timeout = require('../utilities/timeout');

var _timeout2 = _interopRequireDefault(_timeout);

var _poller = require('../utilities/poller');

var _poller2 = _interopRequireDefault(_poller);

var _account = require('../selectors/account');

var _walletTypes = require('../utilities/walletTypes');

var _actionTypes = require('../actionTypes');

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// Is this a 'no wallet/account' error, indicating we have nothing to look up an account from.
var isAccountNotProvidedError = function isAccountNotProvidedError(error) {
  return error.name === 'TimeoutError' || error.name === _constants.NO_WALLET_DETECTED_ERROR;
};

// Is this an error that should garner a retry/re-fetch?
// This is an error that is not one of the 'no wallet' errors,
// it is an error that is network related/occurred during the fetch.
var canRetryError = function canRetryError(error) {
  return error.name !== 'TimeoutError' && error.name !== _constants.NO_WALLET_DETECTED_ERROR;
};

/**
 * Responsible for polling for account changes
 *
 * @param {Object} services
 * @param {Object} actions
 *
 * @returns {function}
 */

exports.default = function (_ref, _ref2) {
  var walletManager = _ref.walletManager;
  var accountChange = _ref2.accountChange,
      accountChangeFailed = _ref2.accountChangeFailed,
      accountNotProvided = _ref2.accountNotProvided;
  return function (store) {
    var dispatch = store.dispatch;

    return (0, _poller2.default)(store, {
      frequency: 1000,

      initialState: { attempts: 0, previousWeb3Provided: null },

      // lifecycle is tied to the app itself
      checkStart: function checkStart(action) {
        return action.type === _actionTypes.APP_INIT;
      },
      checkStop: function checkStop(action) {
        return action.type === _actionTypes.APP_SHUTDOWN;
      },

      checkRun: function checkRun(localState, state) {
        return (0, _account.isInteractive)(state);
      },

      // main function body
      main: function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref3, state) {
          var attempts = _ref3.attempts,
              previousWeb3Provided = _ref3.previousWeb3Provided;

          var _state$account, walletType, address, web3Locked, web3Provided, isConnected, walletConfig, timeoutMs, wallet, nextAddress;

          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _state$account = state.account, walletType = _state$account.walletType, address = _state$account.address, web3Locked = _state$account.web3Locked, web3Provided = _state$account.web3Provided;
                  isConnected = !!address;
                  walletConfig = _walletTypes.walletDefinitions.find(function (def) {
                    return def.type === walletType;
                  });

                  if (!(isConnected && !walletConfig.enablePolling)) {
                    _context.next = 5;
                    break;
                  }

                  return _context.abrupt('return', { attempts: attempts, previousWeb3Provided: web3Provided });

                case 5:
                  if (!(previousWeb3Provided !== null && web3Provided === null || state.account.web3Provided === true || attempts < 5)) {
                    _context.next = 25;
                    break;
                  }

                  _context.prev = 6;
                  timeoutMs = isConnected ? 10000 : 1000;
                  wallet = walletManager.get(walletType, address);
                  _context.next = 11;
                  return (0, _retry2.default)(function () {
                    return (0, _timeout2.default)(wallet.getAddress(), timeoutMs);
                  }, {
                    predicate: canRetryError
                  });

                case 11:
                  nextAddress = _context.sent;

                  if (!(nextAddress !== address)) {
                    _context.next = 15;
                    break;
                  }

                  if (nextAddress) {
                    dispatch(accountChange(nextAddress));
                  } else if (!web3Locked) {
                    dispatch(accountChange(nextAddress));
                  }

                  return _context.abrupt('return', { attempts: 0, previousWeb3Provided: web3Provided });

                case 15:
                  return _context.abrupt('return', { attempts: attempts });

                case 18:
                  _context.prev = 18;
                  _context.t0 = _context['catch'](6);

                  if (!isAccountNotProvidedError(_context.t0)) {
                    _context.next = 24;
                    break;
                  }

                  if (address) {
                    dispatch(accountChange(''));
                  }
                  dispatch(accountNotProvided());
                  return _context.abrupt('return', { attempts: attempts + 1, previousWeb3Provided: web3Provided });

                case 24:

                  dispatch(accountChangeFailed(_context.t0));

                case 25:
                  return _context.abrupt('return', { attempts: attempts, previousWeb3Provided: web3Provided });

                case 26:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, undefined, [[6, 18]]);
        }));

        function main(_x, _x2) {
          return _ref4.apply(this, arguments);
        }

        return main;
      }()
    });
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/middleware/pollAccount.js
// module id = 1289
// module chunks = 0